import React from "react";
import { Modal, Box, Typography, Avatar } from "@mui/material";
import { colors } from "../../common/colors";
import profile from "../../assets/images/profile_img.png";
import Separator from "../Separator";
import SubmitButton from "../SubmitButton";

interface MultiMenuModalProps {
  open: boolean;
  onClose: () => void;
  options?: { title: string; path: string; disabled: boolean }[] | any[];
  onSelect: (options: string) => void;
  avatar?: string;
  avatars?: string[];
  userName?: string;
}

const MultiMenuModal: React.FC<MultiMenuModalProps> = ({ open, onClose, onSelect, options, avatars, userName, avatar }) => {
  const handleOptionSelect = async (path: string, disabled: boolean) => {
    // If the option is disabled, pass an empty string to onSelect
    if (disabled) {
      return false;
    }
    onSelect(path); // Pass the selected path (or empty string) to the onSelect function
    return true
  };

  return (
    <Modal
      slotProps={{ backdrop: { style: { backgroundColor: "rgba(0, 0, 0, 0.2)" } } }}
      style={{ zIndex: 9999 }}
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={styles.wholeBox}>
        {avatar && <Avatar style={{ margin: 0 }} alt={userName?.charAt(0)?.toUpperCase()} src={avatar} />}
        {avatars && (
          <div style={{ display: "flex" }}>
            {avatars?.slice(0, 6).map((image, index) => (
              <img
                alt="User"
                key={index}
                style={{ ...styles.image, marginLeft: index === 0 ? "0px" : "-10px" }}
                src={image ? image : profile}
              />
            ))}
          </div>
        )}
        <Typography sx={{ marginTop: 2 }}>{userName}</Typography>
        <Separator color={colors.farm_gray100} sx={{ height: "2px" }} />
        {options?.map((option, index) => (
          <Box key={index} sx={{ width: "100%" }}>
            <SubmitButton
              sx={{
                marginTop: 1,
                marginBottom: 1,
                paddingLeft: 3,
                justifyContent: "flex-start",
                cursor: option.disabled ? "not-allowed" : "pointer",
                color: option.disabled ? "gray" : "black",
                width: "100%",
              }}
              validate={async () => true}
              onSubmit={() => handleOptionSelect(option.path, option.disabled)}
            >
              {option.title}
            </SubmitButton>
            <Separator color={colors.farm_gray100} sx={{ height: "2px" }} />
          </Box>
        ))}
        <Typography onClick={() => onClose()} sx={{ width: "100%", textAlign: "center", marginTop: 2 }}>
          とじる
        </Typography>
      </Box>
    </Modal>
  );
};

const styles = {
  wholeBox: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: "20px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 2,
    outline: 'none'
  },
  image: {
    width: "26px",
    height: "26px",
    borderRadius: "50%",
    objectFit: "cover" as const,
  },
};

export default MultiMenuModal;
